import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "./../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import * as $ from "jquery";
import "datatables.net";
import "datatables.net-bs4";

@Injectable()
export class CommonService {
  private baseUrl = environment.backEndUrl;
  dataTable: any;
  headers: any;
  token?: any;
  constructor(private router: Router, private toaster: ToastrService, private http: HttpClient) { }

  // Get API
  doGet(url: any, qp: any) {

    let authorizationData =
      "Basic " + btoa(qp.head.username + ":" + qp.head.password);

    this.headers = new HttpHeaders({
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Content-Type": "application/json",
      "X-CSRF-Token": "Fetch",
      "Content-Security-Policy": "upgrade-insecure-requests",
      BPCode: qp.head.BPCode,
      CompanyID: qp.head.CompanyID,
      Authorization: authorizationData,
      AuthControl: JSON.stringify(qp.head.auth_Control)
    });
    console.log(this.baseUrl + url, { params: qp.param, headers: this.headers, })

    return this.http.get(this.baseUrl + url, { params: qp.param, headers: this.headers, responseType: "text" })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable));
  }

  // Post API
  doPost(url: any, data: any) {
    let authorizationData =
      "Basic " + btoa(data.head.username + ":" + data.head.password);
    var Userid = data.head.Userid;
    if (url == 'ProductMaster/BulkUpload') {
      this.headers = new HttpHeaders({
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "enctype": "multipart/form-data",
        "Accept": "application/json",
        "X-CSRF-Token": "Fetch",
        "Content-Security-Policy": "upgrade-insecure-requests",
        Userid: Userid,
        BPCode: data.head.BPCode,
        CompanyID: data.head.CompanyID,
        Authorization: authorizationData,
        AuthControl: JSON.stringify(data.head.auth_Control),
      });
    } else {
      this.headers = new HttpHeaders({
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Content-Type": "application/json",
        "X-CSRF-Token": "Fetch",
        "Content-Security-Policy": "upgrade-insecure-requests",
        Userid: Userid,
        BPCode: data.head.BPCode,
        CompanyID: data.head.CompanyID,
        Authorization: authorizationData,
        AuthControl: JSON.stringify(data.head.auth_Control),
      });
    }
    console.log(this.baseUrl + url, data.data, {
      params: data.param, headers: this.headers, responseType: "text"
    })
    return this.http.post(this.baseUrl + url, data.data, {
      params: data.param, headers: this.headers, responseType: "text"
    })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable));
  }
  // Put API
  doPut(url: any, data: any) {
    let authorizationData = "Basic " + btoa(data.head.username + ":" + data.head.password);
    var Userid = data.head.Userid;

    this.headers = new HttpHeaders({
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "X-CSRF-Token": "Fetch",
      "Content-Security-Policy": "upgrade-insecure-requests",
      Userid: Userid,
      BPCode: data.head.BPCode,
      CompanyID: data.head.CompanyID,
      Authorization: authorizationData,
      AuthControl: JSON.stringify(data.head.auth_Control),
    });
    console.log(this.headers)
    return this.http.put(this.baseUrl + url, data.data, {
      params: data.param, headers: this.headers,
      responseType: "text",
    })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable));
  }
  // Delete API
  doDelete(url: any, data: any) {
    let authorizationData =
      "Basic " + btoa(data.head.username + ":" + data.head.password);

    this.headers = new HttpHeaders({
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Content-Type": "application/json",
      "X-CSRF-Token": "Fetch",
      "Content-Security-Policy": "upgrade-insecure-requests",
      Userid: data.head.Userid,
      BPCode: data.head.BPCode,
      CompanyID: data.head.CompanyID,
      Authorization: authorizationData,
      AuthControl: JSON.stringify(data.head.auth_Control),
    });

    return this.http
      .delete(this.baseUrl + url, {
        params: data.param,
        headers: this.headers,
        responseType: "text",
      })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable));
  }
  //Get Printer API
  doGetPrinter(url: any) {
    this.headers = new HttpHeaders();
    return this.http.get(environment.printerUrl + url, { headers: this.headers })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable))
  }
  doPostPrinter(url: any, data: any) {
    this.headers = null;

    return this.http.post(environment.printerUrl + url, data.data, { params: data.param, headers: this.headers, responseType: "text" })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable))
  }
  // get blob
  doGetBlob(url: any, qp: any) {
    let authorizationData =
      "Basic " + btoa(qp.head.username + ":" + qp.head.password);

    this.headers = new HttpHeaders({
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Content-Type": "application/json",
      "X-CSRF-Token": "Fetch",
      "Content-Security-Policy": "upgrade-insecure-requests",
      BPCode: qp.head.BPCode,
      CompanyID: qp.head.CompanyID,
      Authorization: authorizationData,
      AuthControl: JSON.stringify(qp.head.auth_Control),
    });
    return this.http.get<any>(this.baseUrl + url, { params: qp.param, headers: this.headers, responseType: 'blob' as 'json' })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable))
  }
  doPostAPI(url: any, data: any) {

    this.headers = new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "X-CSRF-Token": "Fetch",
      "Content-Security-Policy": "upgrade-insecure-requests",
      // Userid: Userid,
    });


    return this.http.post('https://api.labelary.com/v1/printers/8dpmm/' + url, data.data, {
      responseType: "blob",
    })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable));
  }
  // Response API
  private extractData(res: Response | any) {
    console.log(body)
    var body = res;

    try {
      return JSON.parse(body);
    } catch (e) {
      return { data: body };
    }
  }
  // Error Handler API
  private handleErrorObservable(error: Response | any) {
    console.log(error)
    if ((error.status >= 400 && error.status < 500) || error.status === 0) {
      let errors = error.message;
      return throwError(() => new Error(errors));
    }
    // else if (error.status > 500 && error.status < 600) {
    //   error.status = JSON.stringify(error.status);
    //   let errors = error.status + " " + error.error;
    //   return throwError(() => new Error(errors));
    // }
    else if (error.status === 500 || error.status === 600) {
      console.log(error)

      error.status = JSON.stringify(error.status);
      let errors = error.status + " " + "Contact to help Desk";
      return throwError(() => new Error(errors));
    }
    // else if(error.status > 600 && error.status <= 700){
    //   error.status = JSON.stringify(error.status);
    //   let errors = error.status + " " + error.error;
    //   return throwError(() => new Error(errors));
    // }
    // else if (error.status == 700) {
    //   error.status = JSON.stringify(error.status);
    //   let errors = error.status + " " + error.error;
    //   return throwError(() => new Error(errors));
    // }
    else {
      error.status = JSON.stringify(error.status);
      let errors = error.status + " " + error.error;
      return throwError(() => new Error(errors));
    }
  }

  doPostFile(url: any, data: any) {
    data.head['Access-Control-Allow-Origin'] = '*'
    this.headers = new HttpHeaders(data.head)
 
    console.log(">>>>>>>>>", this.baseUrl + url, data.data, data.param, this.headers)
    return this.http.post(this.baseUrl + url, data.data, { params: data.param, headers: this.headers, responseType: "text" })
      .pipe(map(this.extractData), catchError(this.handleErrorObservable));
  }
  // Tost Success
  showSuccess(msg: any) {
    this.toaster.success(msg, "Success!", {
      progressBar: true,
      progressAnimation: "decreasing",
      closeButton: true,
    });
  }
  // Tost Error
  showError(msg: any) {
    this.toaster.error(msg, "Error!", {
      progressBar: true,
      progressAnimation: "decreasing",
      closeButton: true,
    });
  }
  // Tost Success
  showInfo(msg: any) {
    this.toaster.info(msg, "Info!", {
      progressBar: true,
      progressAnimation: "decreasing",
      closeButton: true,
    });
  }
  // Set Data Tables
  DateTable(data: any) {
    const table: any = $(data);
    this.dataTable = table.DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: false,
      destroy: true,
    });
  }
  // Date Conversion
  convertDate(data: string) {
    var p = data.split(/\D/g);
    if (p[1].length == 1) {
      p[1] = 0 + p[1];
    }
    if (p[0].length == 1) {
      p[0] = 0 + p[0];
    }
    return [p[2], p[1], p[0]].join("-"); //Accept DD-MM-YYYY / D-M-YYYY // return YYYY-MM-DD
  }

  getYears() {
    var Years = [];
    for (let i = 1; i <= 50; i++) {
      var yr = {
        year: i,
      };
      Years.push(yr);
    }
    return Years;
  }

  getMonths() {
    var Months = [];
    for (let i = 0; i <= 12; i++) {
      var yr = { year: i };
      Months.push(yr);
    }
    return Months;
  }


  // Data Table Custom export
  DataTableExport(data: any, columns: any, filename: any) {
    const table: any = $(data);
    this.dataTable = table.DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: false,
      destroy: true,
      dom: "Bfrtip",
      buttons: [
        {
          title: filename,
          extend: "excel",
          text: "Export",
          exportOptions: {
            columns: columns,
          },
        },
      ],
      bStateSave: true,
    });
  }

  // Get Date
  getTodaySysDate() {
    const today = new Date();
    var date =
      +today.getFullYear() +
      "-" +
      ("0" + (today.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + today.getDate()).slice(-2); //get current system date yyy-mm-dd
    return date;
  }

  // Get Login User Details.
  getInfo() {
    var json = [
      {
        Info: JSON.parse(window.atob(sessionStorage.getItem("token")!)),
        UserData: JSON.parse(window.atob(sessionStorage.getItem("Userkey")!)),
      },
    ];
    return json;
  }
  getKey() {
    let Info = sessionStorage.getItem("Userkey");
    let data = JSON.parse(window.atob(Info!));
    return data;
  }
  // Remove Item From Array
  removeItemFromArray(array: any, element: any) {
    const index = array.indexOf(element);

    // if the element is in the array, remove it
    if (index > -1) {
      // remove item
      array.splice(index, 1);
    }
    return array;
  }
  // Push Item From Array
  addItemFromArray(array: any, element: any) {
    const index = array.indexOf(element);

    // if the element not in the array, Add it
    if (!index) {
      // remove item
      array.push(element);
    }
    return array;
  }

  // Logout User and expired session.
  logout() {
    sessionStorage.removeItem("Userkey");
    sessionStorage.removeItem("token");
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(["login"]);
  }

  //convert the input file into base64 string
  readAsDataURL = (inputFile: any) => {
    var reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new DOMException("Problem parsing input file."));
      };
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(inputFile);
    });
  };
  //convert the Blob to base64 string
  blobToBase64 = (blob: any) => {

    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = () => {

        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }



  encode(text: any) {
    // encode base64 to uint8array/binary
    if (text) { var dd = new TextEncoder().encode(text); return dd } else { return null }
  }
  // decode base64 to uint8array/binary
  decode(text: any) {
    if (text) { return new TextDecoder().decode(text) } else { return null }
  }
}
